import {
  getKpis
} from "../../../helpers/backend_helper";
import {
  apiError,
  kpisSuccess,
  reset_dashboard_flag,
  setFetchParams,
  clearCache
} from "./reducer";

// Tiempo de caducidad de la caché en milisegundos (5 minutos)
const CACHE_EXPIRY_TIME = 5 * 60 * 1000;

export const getDashboardKpis = (params) => async (dispatch, getState) => {
  // Verificar si tenemos datos en caché para estos parámetros
  const state = getState();
  
  // Crear clave de caché normalizada (ordenar keys para consistencia)
  const sortedParams = Object.keys(params).sort().reduce((acc, key) => {
    acc[key] = params[key];
    return acc;
  }, {});
  const cacheKey = JSON.stringify(sortedParams);
  const cachedData = state.Dashboard.cachedKpis[cacheKey];
  
  // Verificar si los parámetros han cambiado
  const lastParams = state.Dashboard.lastFetchParams;
  const paramsChanged = !lastParams || JSON.stringify(sortedParams) !== JSON.stringify(lastParams);
  
  // Si los parámetros cambiaron, invalidar toda la caché
  if (paramsChanged) {
    //console.log('🔄 Parámetros cambiaron, invalidando caché:', { anterior: lastParams, nuevo: sortedParams });
    dispatch(clearCache());
  }
  
  // Si hay datos en caché válidos y los parámetros NO cambiaron, usarlos
  if (!paramsChanged && cachedData && (Date.now() - cachedData.timestamp < CACHE_EXPIRY_TIME)) {
    //console.log('✅ Usando datos de caché (válidos por', Math.round((CACHE_EXPIRY_TIME - (Date.now() - cachedData.timestamp)) / 1000), 'segundos más)');
    // Despachar con estructura correcta
    return dispatch(kpisSuccess({ data: cachedData.data, message: "Datos obtenidos de caché" }));
  }
  
  // Si no hay caché válido o parámetros cambiaron, hacer la petición al API
  //console.log('🌐 Haciendo petición al API con parámetros:', sortedParams);
  dispatch(reset_dashboard_flag());
  dispatch(setFetchParams(sortedParams));
  
  try {
    const response = await getKpis(params);
    const serializableData = {
      data: response.data,
      message: response.message,
      status: response.status_code,
    };

    dispatch(kpisSuccess(serializableData));
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetDashboardFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_dashboard_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};